import { Link } from 'react-router-dom';

function About() {
  return (
    <div className="about-page">
      <header>
        <div className="header-container">
          <Link to="/" className="logo">
            RAOC Studio
          </Link>
          <nav>
            <a href="/#work">Work</a>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </nav>
          <a
            href="https://instagram.com/raocstudio"
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-link"
            aria-label="Follow us on Instagram"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" fill="currentColor"/>
            </svg>
          </a>
          <div className="header-actions">
            <Link to="/contact" className="btn">Start a Project</Link>
          </div>
        </div>
      </header>

      <main className="about-container">
        <div className="about-hero">
          <span className="tag">Random Acts of Craftsmanship</span>
          <h1>About RAOC Studio</h1>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2>Our Philosophy</h2>
            <p>
              RAOC Studio is built on the belief that craftsmanship is more than technique—it's a commitment to integrity, respect for materials, and an understanding that every piece tells a story.
            </p>
            <p>
              We blend traditional Japanese joinery with modern design sensibilities, creating work that honors both heritage and innovation. Each project is approached with the wabi-sabi philosophy: embracing imperfection, authenticity, and the beauty of time.
            </p>
          </section>

          <section className="about-section">
            <h2>What We Do</h2>
            <div className="about-services">
              <div className="service-item">
                <h3>Custom Furniture</h3>
                <p>Handcrafted pieces designed for your space and built to last generations.</p>
              </div>
              <div className="service-item">
                <h3>Restoration</h3>
                <p>Preserving and revitalizing cherished pieces with care and expertise.</p>
              </div>
              <div className="service-item">
                <h3>Built-Ins & Joinery</h3>
                <p>Seamless integration of form and function using traditional techniques.</p>
              </div>
              <div className="service-item">
                <h3>Custom Lighting</h3>
                <p>Unique fixtures crafted from reclaimed materials and natural elements.</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>The Approach</h2>
            <p>
              Every project begins with conversation. We want to understand not just what you need, but why you need it. What's the function? What's the feeling you're after? What constraints are we working within?
            </p>
            <p>
              From there, we design with intention, source materials thoughtfully, and build with the kind of attention that can't be rushed. The result is work that feels right—pieces that serve their purpose and earn their place in your life.
            </p>
          </section>

          <section className="about-cta">
            <h2>Let's Build Something Together</h2>
            <p>Have a project in mind? Let's talk about it.</p>
            <Link to="/contact" className="btn">Start a Conversation</Link>
          </section>
        </div>

        <p className="back-link">
          <Link to="/">← Back to home</Link>
        </p>
      </main>

      <footer>
        <div className="footer-container">
          <div>© 2025 RAOC Studio — Craftsmanship • Quality • Integrity • Tradition • Artistry</div>
          <div className="footer-links">
            <Link to="/#work">Work</Link>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default About;
